import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import _ from "lodash";
import "../index.css"

import { Button, CheckboxField, TextInputField, DropDownField, AutoCompleteField } from '../../../../helpers'
import Messages from '../../../../helpers/Messages';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Tooltip } from "primereact/tooltip";
import { Dialog } from 'primereact/dialog';

import Loading from '../../../../common/Loading';
import AddShippingAddress from '../../../../common/AddShippingAddress';
import BillingAddressCards from "../../../../common/BillingAddressCards"
import ShippingAddressCards from "../../../../common/ShippingAddressCards"

import DispatchSellerPOItems from './DispatchSellerPOItems'
import TrackingDetails from './TrackingDetails'

import { initialTrackingDetails } from '../../../../validation/dispatchTrackingDetailsValidation'

import { searchUserRoles } from '../../../../services/api/user';
import { addCompanyBranchShipAddrData } from '../../../../services/api/companyBranchShipAddr';

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { fetchCountries, fetchHSNMasterData, fetchPinCodes, fetchStates } from '../../../../services/redux/reducers/commonThunk';

import { getMaterialMasterDetailsTooltip, round, sortArrayOfObjectsInAlphabeticalOrder, logisticHSNOptions, checkPermissions } from '../../../../utils'

import { DECIMAL_LIMIT } from '../../../../constants'
import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';
import { searchIncrementalReqLogs } from '../../../../services/api/incrementalReqLogs';

const itemsGroupedByOptions = [
    {label:'Buyer Req Item', value: 'buyerReqItemId'},
    {label:'Buyer PO Item', value: 'buyerPOItemId'}
]

const TCSRateOptions = [
    { label: "0", value: 0 },
    { label: "0.1", value: 0.1 },
    { label: "2", value: 2 }
]

const biofuelActivityTypes = [
    { label: "CONTRACT MANUFACTURING", value: "CONTRACT MANUFACTURING" },
    { label: "MANUFACTURING", value: "MANUFACTURING" },
    { label: "TRADING", value: "TRADING" }
]

const CreateDispatchNote = (props) => {
    const { selectedBuyerBillAddrId, selectedBuyerShipAddrId, setSelectedBuyerShipAddrId, buyerCompanyBillAddrs, buyerCompanyBranchShipAddrs, pmBranches, setBuyerCompanyBranchShipAddrs } = props

    const [visibleAddNewShippingAddr, setVisibleAddNewShippingAddr] = useState(false)

    const [dispatchSellerPOs, setDispatchSellerPOs] = useState({})
    const [dispatchSellerPOItems, setDispatchSellerPOItems] = useState({})
    const [trackingDetails, setTrackingDetails] = useState({ ...initialTrackingDetails })
    const [trackingDetailsFormErrors, setTrackingDetailsFormErrors] = useState({})
    const [buyerCompany, setBuyerCompany] = useState(null)
    const [buyerCompanyUsers, setBuyerCompanyUsers] = useState([])
    const [isGenerateInvoice, setIsGenerateInvoice] = useState(true)
    const [suppliedToExporter, setSuppliedToExporter] = useState(false)
    const [TCSRate, setTCSRate] = useState(0)
    const [biofuelActivityType, setBiofuelActivityType] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [logisticAmount, setLogisticAmount] = useState(0)
    const [logisticsHSNCode, setLogisticsHSNCode] = useState(null)
    const [searchedLogisticsHSNCodes, setSearchedLogisticsHSNCodes] = useState([])
    const [companySupplyTypes, setCompanySupplyTypes] = useState([])
    const [supplyType, setSupplyType] = useState(null)
    const [totalBuyerPOLogisticAmount, setTotalBuyerPOLogisticAmount] = useState(0)
    const [searchedBuyerCompanyUsers, setSearchedBuyerCompanyUsers] = useState([])
    const [vehicleNo, setVehicleNo] = useState(null)
    const [recipientUser, setRecipientUser] = useState(null)
    const [showRecipientUserInput, setShowRecipientUserInput] = useState(false)
    const [incrementalReqLogs, setIncrementalReqLogs] = useState([])
    const [isLogisticsDeliveryAtActuals, setIsLogisticsDeliveryAtActuals] = useState(false)
    const [itemsGroupedBy, setItemsGroupedBy] = useState("buyerReqItemId")

    const states = useSelector((state) => state.common.states)
    const countriesData = useSelector((state) => state.common.countries)
    const pinCodes = useSelector(state => state.common.pinCodes)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(dispatchSellerPOs[0]?.pmCompanyId)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchPinCodes())
        dispatch(fetchStates())
        dispatch(fetchCountries())
        dispatch(fetchHSNMasterData())
    }, [])
    
    useEffect(() => {
        setDispatchSellerPOItems(props.selectedDispatchSellerPOItems)
        setDispatchSellerPOs(props.selectedDispatchSellerPOs)
        
        if(props.selectedDispatchSellerPOs?.length > 0){
            setBuyerCompany({
                companyId: props.selectedDispatchSellerPOs[0].bPOcompanyId,
                tags: props.selectedDispatchSellerPOs[0].tags
            })
            const  buyerCompanyUserSearchParams = { 
                companyIds: [props.selectedDispatchSellerPOs[0].bPOcompanyId], 
                statusId: 1, 
                include: [{ model: "user", attributes: ["firstName", "lastName", "emailId", "phoneNumber"] }], 
                paginator: false
            }
            
            getBuyerCompanyUsersData(buyerCompanyUserSearchParams)

            const reqNoArr = props.selectedDispatchSellerPOs.map(eachPO => eachPO.buyerReqDocNo)
            fetchIncrementalLogs(reqNoArr)
        }else{
            setBuyerCompany(null)
            getBuyerCompanyUsersData([])
        }
        
        if(props.companySupplyTypes && props.companySupplyTypes?.length > 0){
            if (props.selectedDispatchSellerPOs[0]?.isBuyerReqTaxExempted){
                setSupplyType(4)
                setCompanySupplyTypes(props.companySupplyTypes)
            }else{
                let relatedCompanySupplyType = []
                props.companySupplyTypes.map(eachSupplyType => {
                    if(eachSupplyType.supplyType === "B2B" || eachSupplyType.supplyType === "B2C" || eachSupplyType.supplyType === "SEZWP" || eachSupplyType.supplyType === "SEZWOP"){
                        if(eachSupplyType.supplyType === "B2B"){
                            setSupplyType(eachSupplyType.supplyTypeId)
                        }
                        relatedCompanySupplyType.push(eachSupplyType)
                    }
                })
                setCompanySupplyTypes(relatedCompanySupplyType)
            }
        }
    }, [])

    useEffect(()=>{
        if(buyerCompany && buyerCompany.tags){
            if(buyerCompany.tags.groupBuyerInvoiceItemsBy){
                setItemsGroupedBy(buyerCompany.tags.groupBuyerInvoiceItemsBy)
            }
        }
    }, [buyerCompany])

    const showBiofuelActivityType = useMemo(() => {
        let allCategoryIds = []
        Object.keys(dispatchSellerPOItems).map(key => {
            let sellerPOItems = dispatchSellerPOItems[key]
            sellerPOItems.forEach(eachSellerPOItem => allCategoryIds.push(eachSellerPOItem.categoryId))
        })
        allCategoryIds = _.compact(_.uniqBy(allCategoryIds))
        return allCategoryIds.includes(4)
    }, [dispatchSellerPOItems])

    const fetchIncrementalLogs = async (docNos) => {
        const incrementalLogsResponse = await searchIncrementalReqLogs({docNos: docNos})
        
        if(incrementalLogsResponse.data.length > 0){
            setIsGenerateInvoice(false)
            setIncrementalReqLogs(incrementalLogsResponse.data)
        }
    }
    
    const getBuyerCompanyUsersData = async (searchParams) => {
        // setIsLoading(true)
        const buyerCompanyUsersDataResponse = await searchUserRoles({...searchParams})
        // console.log("buyerCompanyUsersData-response", buyerCompanyUsersDataResponse)
        // setIsLoading(false)
        if(buyerCompanyUsersDataResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: buyerCompanyUsersDataResponse.data.error, life: 3000}))
        }
        else{
            let usersList = buyerCompanyUsersDataResponse.data.data.map(eachUser => {
                return {
                    userId: eachUser.userId,
                    fullName: eachUser["user.firstName"] + " " + (eachUser?.["user.lastName"] ? eachUser["user.lastName"] : ''),
                    phoneNumber: eachUser["user.phoneNumber"]
                }
            })

            usersList = _.uniqBy(usersList, 'userId');
            usersList = sortArrayOfObjectsInAlphabeticalOrder(usersList, 'fullName')
            
            setBuyerCompanyUsers(usersList)

            let relatedDispatchSellerPO = props.selectedDispatchSellerPOs.find(eachDispatchNote => eachDispatchNote.bPORecipientUserId)
            if(relatedDispatchSellerPO){
                let relatedUser = usersList.find(eachUser => eachUser.userId === relatedDispatchSellerPO.bPORecipientUserId)
                if(relatedUser){
                    setRecipientUser(relatedUser)
                    setShowRecipientUserInput(true)
                }
            }
        }
    }

    const handleDispatchQtyChange = (event, key, sellerPOItemId, sellerPOId) => {
        dispatchSellerPOItems[key].map(sellerPOItem => {
            if (sellerPOItem.sellerPOItemId === sellerPOItemId) {
                if (event.target.name === "dispatchQty") {
                    const decimalLimitRegex = new RegExp(`^\\d*\\.?\\d{0,${DECIMAL_LIMIT}}$`)

                    if (!decimalLimitRegex.test(event.target.value)) {
                        return dispatch(raiseToast({ severity: 'error', detail: `Maximum ${DECIMAL_LIMIT} decimal places allowed` }))
                        
                    }
                    let availableQty = round(sellerPOItem.availableDispatchQuantity, DECIMAL_LIMIT)
                    if (event.target.value > availableQty) {
                        dispatch(raiseToast({ severity: 'warn', detail: `Available Qty : ${availableQty} Only`, life: 3000 }))
                    } else {
                        sellerPOItem.dispatchQty = event.target.value
                    }
                }else{
                    sellerPOItem[event.target.name] = event.target.value
                }
            }
        })

        let selectedBuyerPOIds = []
        let dispatchQtyEntered = false
        let isLogisticOptionDeliveryAtActuals = false
        let totalBuyerPOLogisticAmount = Object.keys(dispatchSellerPOItems).reduce((total, sellerPOItemId) => {
            dispatchSellerPOItems[sellerPOItemId].forEach(sellerPOItem => {
                if (sellerPOItem.dispatchQty > 0 && !selectedBuyerPOIds.includes(sellerPOItem.buyerPOId)) {
                    selectedBuyerPOIds.push(sellerPOItem.buyerPOId)
                    total += sellerPOItem.bPOLogisticsBeforeTax || 0

                    if(!dispatchQtyEntered){
                        dispatchQtyEntered = true
                    }

                    if (sellerPOItem.bQuoteLogisticsOption?.toLowerCase() === "delivery at actuals") {
                        isLogisticOptionDeliveryAtActuals = true
                    }
                }
            })

            return total
        }, 0)

        totalBuyerPOLogisticAmount = totalBuyerPOLogisticAmount > 0 || dispatchQtyEntered ? totalBuyerPOLogisticAmount : 0
        setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
        setLogisticAmount(totalBuyerPOLogisticAmount)

        if(isLogisticOptionDeliveryAtActuals){
            setIsLogisticsDeliveryAtActuals(true)
        }else{
            setIsLogisticsDeliveryAtActuals(false)
        }

        setDispatchSellerPOItems({ ...dispatchSellerPOItems })
    }

    const handleLogisticAmountChange = (event) => {
        let logisticAmountValue = event.target.value
        if(event.target.value === ""){
            logisticAmountValue = 0
        }
        if(!isLogisticsDeliveryAtActuals && logisticAmountValue > totalBuyerPOLogisticAmount){
            logisticAmountValue = 0
        }
        setLogisticAmount(logisticAmountValue)
    }

    const searchLogisticsHSNs = (event) => {
        const relatedLogisticHSNs = logisticHSNOptions.filter(eachHSN => eachHSN.label.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedLogisticHSNs.length > 0){
            setSearchedLogisticsHSNCodes(relatedLogisticHSNs)
        }
    }

    const handleLogisticHSNChange = (e) => {
        setLogisticsHSNCode(e.target.value)
    }

    const handleClickEditInvGSTRateandHSN = (event, key, sellerPOItemId, sellerPOId, inputType) => {
        dispatchSellerPOItems[key].map(sellerPOItem => {
            if (sellerPOItem.sellerPOItemId === sellerPOItemId) {
                if(inputType === "invGSTRate"){
                    sellerPOItem.isEditGSTRate = true
                }

                if(inputType === "invHSNCode"){
                    sellerPOItem.isEditHSNCode = true
                }
            }
        })

        setDispatchSellerPOItems({ ...dispatchSellerPOItems })
    }

    const handleInvGSTandHSNChange = (event, key, sellerPOItemId, sellerPOId) => {

        dispatchSellerPOItems[key].map(sellerPOItem => {
            if (sellerPOItem.sellerPOItemId === sellerPOItemId) {
                if(event.target.name === "invGSTRate"){
                    if(event.target.value < sellerPOItem.GSTRate){
                        dispatch(raiseToast({ severity: 'warn', detail: `GSTRate can't be below the seller PO GST Rate : ${sellerPOItem.GSTRate}`, life: 3000 }))
                    }else{
                        sellerPOItem.invGSTRate = event.target.value
                    }
                }

                if(event.target.name === "invHSNCode"){
                    sellerPOItem.invHSNCode = event.target.value
                }
            }
        })

        let selectedBuyerPOIds = []
        let dispatchQtyEntered = false
        let isLogisticOptionDeliveryAtActuals = false
        let totalBuyerPOLogisticAmount = Object.keys(dispatchSellerPOItems).reduce((total, sellerPOItemId) => {
            dispatchSellerPOItems[sellerPOItemId].forEach(sellerPOItem => {
                if (sellerPOItem.dispatchQty > 0 && !selectedBuyerPOIds.includes(sellerPOItem.buyerPOId)) {
                    selectedBuyerPOIds.push(sellerPOItem.buyerPOId)
                    total += sellerPOItem.bPOLogisticsBeforeTax || 0
                }

                if(!dispatchQtyEntered){
                    dispatchQtyEntered = true
                }

                if (sellerPOItem.bQuoteLogisticsOption?.toLowerCase() === "delivery at actuals") {
                    isLogisticOptionDeliveryAtActuals = true
                }
            })
            return total
        }, 0)

        totalBuyerPOLogisticAmount = totalBuyerPOLogisticAmount > 0 || dispatchQtyEntered ? totalBuyerPOLogisticAmount : 0
        setTotalBuyerPOLogisticAmount(totalBuyerPOLogisticAmount)
        setLogisticAmount(totalBuyerPOLogisticAmount)

        if(isLogisticOptionDeliveryAtActuals){
            setIsLogisticsDeliveryAtActuals(true)
        }else{
            setIsLogisticsDeliveryAtActuals(false)
        }

        setDispatchSellerPOItems({ ...dispatchSellerPOItems })
    }

    const searchBuyerCompanyUsers = (event) => {
        const relatedBuyerCompanyUsers = buyerCompanyUsers.filter(eachUser => eachUser.fullName.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedBuyerCompanyUsers.length > 0){
            setSearchedBuyerCompanyUsers(relatedBuyerCompanyUsers)
        }else{
            setSearchedBuyerCompanyUsers(["This is empty"])
        }
    }

    const handleRecipientUserChange = (event) => {
        setRecipientUser(event.target.value)
    }

    const handleVehicleNumberChange = (event) => {
        setVehicleNo(event.target.value?.toUpperCase())
    }

    const handleSubmit = async () => {
        let trimmedVehicleNo = vehicleNo ? vehicleNo.trim() : null

        if (trimmedVehicleNo === '') {
            trimmedVehicleNo = null;
        }

        if (trimmedVehicleNo && (trimmedVehicleNo.length < 9 || trimmedVehicleNo.length > 15)) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Vehicle number length should be between 9 to 15', life: 3000 }));
        }

        let selectedLogisticHSNCode = null
        if(logisticsHSNCode){
            selectedLogisticHSNCode = logisticsHSNCode.value
        }

        const allPOSourcesAreByNormal = dispatchSellerPOs.every(eachSellerPO => eachSellerPO.bPOSource === "Normal")

        if (!allPOSourcesAreByNormal){
            return dispatch(raiseToast({ severity: 'warn', detail: 'Buyer PO document details are not updated, please update to proceed', life: 3000 }))
        }
        
        props.handleSubmitCreateDispatch(dispatchSellerPOItems, logisticAmount, trackingDetails, isGenerateInvoice, supplyType, selectedLogisticHSNCode, totalBuyerPOLogisticAmount, recipientUser, trimmedVehicleNo, dispatchSellerPOs, isLogisticsDeliveryAtActuals, itemsGroupedBy, suppliedToExporter, TCSRate, biofuelActivityType, showBiofuelActivityType)
    }

    const fileUploadHandler = ({ files, options }) => {
        const [file] = files;
        const fileReader = new FileReader();
        if(file.size > 5242880){
			options.clear()
			return dispatch(raiseToast({severity:'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000}))
		}
        fileReader.onload = (e) => {
            uploadTrackingDocument(file.objectURL, file.name, e.target.result);
        };
        fileReader.readAsDataURL(file);
        options.clear()
    }

    const uploadTrackingDocument = async (fileURL, fileName, dataURI) => {

        let data = {
            url: fileURL,
            documentName: "DISPATCH_TRACKING",
            fileName,
            dataURI
        }
        trackingDetails.trackingDocument = data
        setTrackingDetails({ ...trackingDetails })
    }

    const removeTrackingDocument = () => {
        trackingDetails.trackingDocument = null
        setTrackingDetails({ ...trackingDetails })
    }

    const handleAddShippingAddressSubmit = async (formResult, requirement) => {
        if (window.confirm("Do you want to add shipping address?")) {
            let companyId = buyerCompany.companyId
            let branchId = props.selectedDispatchSellerPOs[0].bPObranchId

            if (formResult) {
                setIsLoading(true)
                const { address, city, pinCode, stateId, countryId } = formResult
                const data = { companyId, branchId, city, pinCode, stateId, shipAddr: address, countryId }
                const response = await addCompanyBranchShipAddrData({ ...data })

                if (response.failure) return dispatch(raiseToast({ severity: 'error', summary: 'Add Shipping Address', detail: response.data.error, life: 3000 }))

                const newShiipingAddress = {
                    shipAddrId: response.data.shipAddrId,
                    shipAddr: response.data.shipAddr,
                    city: response.data.city,
                    stateId: response.data.stateId,
                    countryId: response.data.countryId
                }

                const newShippAddrList = [...buyerCompanyBranchShipAddrs, newShiipingAddress]

                setBuyerCompanyBranchShipAddrs(newShippAddrList)
                setSelectedBuyerShipAddrId(newShiipingAddress.shipAddrId)
                setVisibleAddNewShippingAddr(false)

                setIsLoading(false)
            }
        }
    }

    const createDispatchFooter = () => {
        return (
            <div className="flex flex-column justify-content-center align-items-center">
                <Button
                    label="Only Create Preview Invoice"
                    onClick={props.handleReplacementItemsRejectClick}
                    className="small-btn align-items-center "
                    autoFocus
                    applyThrottle={true}
                    style={{ width: "250px" }}
                />
                <Button
                    label="Replace products"
                    onClick={props.handleReplacementItemsAcceptClick}
                    disabled={itemsGroupedBy === "buyerPOItemId"}
                    className="small-btn save-btn mt-2 align-items-center "
                    style={{backgroundColor: '#f2b55a', border: "1px solid #f2b55a", width: '250px'}}
                    autoFocus
                    applyThrottle={true}
                />
                <Button
                    label="Rename Products"
                    onClick={props.handleOnClickRenameProducts}
                    className="small-btn save-btn mt-2 align-items-center "
                    style={{backgroundColor: '#a1a1f7', border: "1px solid #a1a1f7", width: '250px'}}
                    autoFocus
                    applyThrottle={true}
                />
            </div>
        )
    }

    const createPreviewInvoiceConfirm = (confirmMessages) => {
        return(
            confirmMessages.map(eachMessage => {
                return <div style={{ width: "400px"}}><Messages messages={eachMessage.detail} sticky severity="warn" /></div>
            })
        )
    }
    
    let confirmMessages = [{ severity: 'warn', summary: 'Warning', detail: 'Logistics on Actual was selected, please ensure correct logistics are entered above.', sticky: true, closable: false }]
    if (isLogisticsDeliveryAtActuals) {
        if (!totalBuyerPOLogisticAmount && logisticAmount == 0) {
        } else {
            let logisticConfirmMessage = { severity: 'warn', detail: 'Logistics on Actual was selected, please ensure correct logistics are entered above.', sticky: true, closable: false }
            if(logisticAmount < totalBuyerPOLogisticAmount){
                let lowerLogisticAmountMessage = { severity: 'warn', detail: 'Entered logistics amount is lower than PO logistics amount.', sticky: true, closable: false }
                confirmMessages = [lowerLogisticAmountMessage, ...confirmMessages]
            }
            confirmMessages = [logisticConfirmMessage, ...confirmMessages]
        }
    } else {
        if (totalBuyerPOLogisticAmount > 0 && logisticAmount == 0) {
            let logisticMessage = { severity: 'warn', detail: 'BuyerPO logistic was there.', sticky: true, closable: false }
            confirmMessages = [logisticMessage, ...confirmMessages]
        }
    }

    let isInvoiceAllowed = true
    const invoicingAllowedPMBranchesIds = []
    pmBranches.map(eachPMBranch => {
        if (eachPMBranch.isInvoicingEnabled) {
            invoicingAllowedPMBranchesIds.push(eachPMBranch.branchId)
        }
    })
    const selectedPMBranchIds = props.selectedDispatchSellerPOs.map(eachSelectedPO => eachSelectedPO.pmBranchId)

    selectedPMBranchIds.map(eachPMBranchId => {
        const isInvoicingForPMBranchAllowed = invoicingAllowedPMBranchesIds.includes(eachPMBranchId)
        if (!isInvoicingForPMBranchAllowed) {
            isInvoiceAllowed = false
        }
    })

    let createDispatchNoteDisableCond = false
    if (!isInvoiceAllowed) {
        createDispatchNoteDisableCond = true

        let relatedDispatchSellerPOItems = []
        Object.keys(dispatchSellerPOItems).forEach(key => relatedDispatchSellerPOItems = [...relatedDispatchSellerPOItems, ...dispatchSellerPOItems[key]])
        if (relatedDispatchSellerPOItems?.length) {
            const sellerPOItemsWithQty = relatedDispatchSellerPOItems?.filter(eachPOItem => parseFloat(eachPOItem.dispatchQty))
            const areServiceHSNsProducts = sellerPOItemsWithQty.every(eachPOItem => {
                if(eachPOItem.HSNCode.toString().slice(0, 2) === '99'){
                    return true
                }
                return false
            })

            if (areServiceHSNsProducts) {
                createDispatchNoteDisableCond = false
            }
        }
    }

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    let totalBuyerPOLogisticAmountText = totalBuyerPOLogisticAmount
    if(isLogisticsDeliveryAtActuals){
        totalBuyerPOLogisticAmountText = totalBuyerPOLogisticAmount ? `${totalBuyerPOLogisticAmount} + On Actuals` : "On Actuals"
    }

    const {isPermitted: canAddNewShipAddress} = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [212] })

    const { isPermitted: isTCSEditable } = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [264] })

    return (
        <>
            {!isInvoiceAllowed &&
                <div className="p-card mb-1 message-container mt-1 flex flex-row justify-content-between py-2 bg-red-100" style={{ 'backgroundColor': 'red' }}>
                    <p className='text-red-500'>Invoice is disabled. Only service HSN products can be processed.</p>
                </div>
            }
            {   
                <div className='flex flex-row justify-content-end mb-2'>
                    <span className='sm-text mt-2'>Items grouped by: </span> 
                    <DropDownField name="itemsGroupedBy" options={itemsGroupedByOptions} value={itemsGroupedBy} onChange={(event) => setItemsGroupedBy(event.target.value)} disabled />
                </div>
            }
            {
                Object.keys(dispatchSellerPOItems)?.map(key => {
                    let buyerReqItemId = key
                    let groupingItemId = key
                    let sellerPOItems = dispatchSellerPOItems[key]
                    let materialId = sellerPOItems[0].materialId
                    let buyerProductName = sellerPOItems[0]?.productName // sellerPOItems[0].companyProdName ? sellerPOItems[0]?.companyProdName : sellerPOItems[0]?.productName
                    let buyerProductSpecifications = sellerPOItems[0]?.productSpecification // sellerPOItems[0].companyProdSpec ? sellerPOItems[0]?.companyProdSpec : sellerPOItems[0]?.productSpecification
                    let buyerUOM = sellerPOItems[0]?.companyERPUOM ? sellerPOItems[0]?.companyERPUOM : sellerPOItems[0]?.UOM

                    return (
                        <div key={groupingItemId} className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }} >
                            <div className='flex flex-column md:flex-row md:justify-content-between' style={{ flex: 1}}>
                                <div style={{ marginLeft: "10px", alignItems: "center" }}>
                                    <p className="mb-0 mt-2"><span style={{ fontWeight: 700 }}>
                                        <span className={`custom-tool-tip-${materialId}`}>{materialId}</span>
                                        <Tooltip target={`.custom-tool-tip-${materialId}`} position="top" autoHide={true}>
                                            {getMaterialMasterDetailsTooltip({...sellerPOItems[0], brandName: sellerPOItems[0]?.brandName, productName: sellerPOItems[0]?.productName, productSpecification: sellerPOItems[0]?.productSpecification , variantName: sellerPOItems[0]?.variantName, renderHTML : true})}
                                        </Tooltip>
                                        </span> | {buyerProductName} | {buyerProductSpecifications} </p> {/* | {sellerPOItems[0]?.UOM} */}
                                </div>
                                <div style={{ marginLeft: "10px", alignItems: "center" }}>
                                    <p className="mb-0 mt-2">
                                        <span style={{ fontWeight: 700 }}></span> {getMaterialMasterDetailsTooltip({productName: sellerPOItems[0]?.companyProdName, productSpecification: sellerPOItems[0]?.companyProdSpec, renderHTML : false})}
                                    </p>
                                </div>
                            </div>
                            <div className="mt-1" style={{ paddingLeft: 15, paddingRight: 15 }}>
                                <div>
                                    <div style={{ height: 6 }} ></div>
                                    {
                                        sellerPOItems.map((sellerPOItem, index) => {
                                            let displayLabel = false
                                            if (index === 0) {
                                                displayLabel = true
                                            }

                                            const relatedSellerPO = dispatchSellerPOs.find(eachDisplaySellerPO => eachDisplaySellerPO.sellerPOId === sellerPOItem.sellerPOId)

                                            return (
                                                <DispatchSellerPOItems
                                                    buyerReqItemId={buyerReqItemId}
                                                    groupingItemId={groupingItemId}
                                                    sellerPO={relatedSellerPO}
                                                    sellerPOItem={sellerPOItem}
                                                    displayLabel={displayLabel}
                                                    isQtyCannotBeChanged={false}
                                                    handleDispatchQtyChange={handleDispatchQtyChange}
                                                    HSNMasterData={HSNMasterData}
                                                    handleInvGSTandHSNChange={handleInvGSTandHSNChange}
                                                    handleClickEditInvGSTRateandHSN={handleClickEditInvGSTRateandHSN}
                                                    buyerCompany={buyerCompany}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <Loading visible={isLoading}/>
            <div className="p-card">
                <h5 className="text-600">Shipping Address</h5>
                <ShippingAddressCards 
                    shippingAddresses={buyerCompanyBranchShipAddrs} 
                    selectedAddressId={selectedBuyerShipAddrId} 
                    handleShippingAddress={props.handleShippingAddress} 
                    setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr}
                    showAddShipAddr={selectedBuyerShipAddrId === null && buyerCompanyBranchShipAddrs.length > 0 && canAddNewShipAddress}
                />
                <div className="hr-line"></div>
                <h5 className="text-600 mt-3">Billing Address</h5>
                <BillingAddressCards billingAddresses={buyerCompanyBillAddrs} selectedAddressId={selectedBuyerBillAddrId} handleBillingAddress={props.handleBillingAddress} />
            </div>
            <Dialog header="Add New Shipping Address" visible={visibleAddNewShippingAddr} onHide={() => setVisibleAddNewShippingAddr(false)}>
                <AddShippingAddress stateList={states} setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr} setShippingAddressesList={setBuyerCompanyBranchShipAddrs} shippingAddressesList={buyerCompanyBranchShipAddrs} handleSubmit={handleAddShippingAddressSubmit} countriesData={countriesData} pinCodesData={pinCodes} />
            </Dialog>
            {
                <>
                    <h4 className="mt-0 ml-2 mb-2">Logistic Amount</h4>
                    <div className="p-card col-12 flex flex-column md:flex-row mb-2 m-0" style={{ padding: 0 }} >
                        <div className="flex flex-column">
                            <div className="flex flex-column md:flex-row col-12 lg:col-6 md:col-4 md:pl-0 pl-1 ml-2">
                                <div className="flex flex-column col-12 lg:col-6 pl-0 md:pl-2">
                                    <TextInputField name="Logistic Amount" labelText="Logistic Amount" keyfilter="pnum" value={logisticAmount} onChange={(event) => handleLogisticAmountChange(event)} />
                                </div>
                                {
                                    isHSNEntryAllowed ? 
                                    (
                                        isGenerateInvoice &&
                                            <div className="flex flex-column col-12 lg:col-6 pl-0">
                                                <AutoCompleteField name="logisticsHSNCode" labelText="Logistic HSN" field="label" placeholder="Select HSN" value={logisticsHSNCode} suggestions={searchedLogisticsHSNCodes} searchMethod={searchLogisticsHSNs} onChange={(event) => handleLogisticHSNChange(event)} dropdown forceSelection />
                                            </div>
                                    )
                                    :
                                    null
                                }
                                <div className="flex align-items-center mt-2 col-12 lg:col-12 pl-0 md:pl-2">
                                    <i className="pi pi-info-circle custom-target-icon ml-2 mt-1 mr-1 i-icon"></i>
                                    <p>BuyerPO total logistic amount: <span style={{ color: "red" }}>{ totalBuyerPOLogisticAmountText}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <h4 className="mt-0 ml-2 mb-2">Other Details</h4>
            <div className='p-card p-0 pl-2 pt-2 pb-2 flex'>
                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                    <DropDownField name="TCSRate" labelText="TCS Rate(%)" options={TCSRateOptions} optionLabel="label" optionValue="value" value={TCSRate} onChange={(e) => setTCSRate(e.target.value)} permissions={[264]} />
                </div>
                {
                    showBiofuelActivityType ? 
                    <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                        <DropDownField name="biofuelActivityType" labelText="Biofuel Activity Type" options={biofuelActivityTypes} optionLabel="label" optionValue="value" value={biofuelActivityType} onChange={(e) => setBiofuelActivityType(e.target.value)} />
                    </div> : null
                }
            </div>
            <div>
                <TrackingDetails
                    trackingDetails={trackingDetails}
                    setTrackingDetails={setTrackingDetails}
                    logisticPartners={props.logisticPartners}
                    trackingDetailsFormErrors={trackingDetailsFormErrors}
                    fileUploadHandler={fileUploadHandler}
                    removeTrackingDocument={removeTrackingDocument}
                />
            </div>
            <div className='flex flex-column md:flex-row'>
                {
                    isGenerateInvoice ?
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 pt-0 mt-1">
                            <DropDownField name="supplyType" labelText="Supply Type" options={companySupplyTypes} optionLabel="supplyType" optionValue="supplyTypeId" value={supplyType} onChange={(event) => setSupplyType(event.target.value)} disabled={!isGenerateInvoice || props.selectedDispatchSellerPOs[0]?.isBuyerReqTaxExempted} />
                        </div> : ""
                }
                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0 md:ml-1 pt-0 mt-1">
                    <TextInputField name="vehicleNo" labelText="Vehicle No" placeholder="Vehicle No" value={vehicleNo} maxLength={15} onChange={e => handleVehicleNumberChange(e)} />
                </div>
                {
                    showRecipientUserInput ?
                        <>
                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0 pt-0 mt-1">
                                <label htmlFor="recipientUserId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                    Recipient User
                                    <Tooltip target=".custom-target-icon" position="right" content="If user not found plase add the user in company and refresh the page" />
                                    <i className="pi pi-info-circle custom-target-icon ml-2"></i>
                                </label>
                                <AutoCompleteField name="recipientUserId" suggestions={searchedBuyerCompanyUsers} field="fullName" value={recipientUser} onChange={e => handleRecipientUserChange(e)} searchMethod={searchBuyerCompanyUsers} dropdown forceSelection />
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0 pt-0 mt-1">
                                <TextInputField name="recipientUserPhoneNo" labelText="Recipient User Phone No" placeholder="" value={recipientUser?.phoneNumber} onChange={e => handleRecipientUserChange(e)} disabled />
                            </div>
                        </>
                        :
                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0 md:pt-5" style={{paddingTop:""}}>
                            <span onClick={() => setShowRecipientUserInput(true)} style={{ cursor: "pointer" }}><i className='pi pi-plus-circle mr-1' style={{ color: '#00baaa' }} />Add Recipient User</span>
                        </div>
                }
            </div>
            <div className='flex flex-row mt-1'>
                <div className='flex flex-row justify-content-center'>
                    <div className='ml-2'><CheckboxField name="generateInvoice" inputId="generateInvoice" label="Generate Invoice" checked={isGenerateInvoice} onChange={(event) => {setIsGenerateInvoice(event.target.checked) ; setLogisticsHSNCode(0)}} disabled={!buyerCompany?.tags?.canDelayInvoice} /></div>
                    <div>
                        <Tooltip target=".custom-target-icon" position="right" content="Please check with city-head if you want to delay invoice creation to a later date" />
                        <i className="pi pi-info-circle custom-target-icon ml-2 mt-1 i-icon"></i>
                    </div>
                </div>
                <div className='flex flex-row justify-content-center'>
                    <div className='ml-2'><CheckboxField name="suppliedToExporter" inputId="suppliedToExporter" label="Supplied to Exporter (0.1% GST Applicable)" checked={suppliedToExporter} onChange={(event) => {setSuppliedToExporter(event.target.checked)}} disabled={!buyerCompany?.tags?.isMerchantExporter} /></div>
                </div>
            </div>
            <Button className="small-btn mt-3 mb-2 md:mt-1 md:mb-1" style={{ float: "right" }} label={!isGenerateInvoice ? "Create Dispatch Note" : "Create Dispatch Note and Preview Invoice"} onClick={handleSubmit} disabled={createDispatchNoteDisableCond} />
            <ConfirmDialog 
                visible={props.isConfirmReplaceDialogVisible} 
                onHide={() => props.setIsConfirmReplaceDialogVisible(false)} 
                header={"Please select option"}
                message={()=>createPreviewInvoiceConfirm(confirmMessages)}
                footer={() => createDispatchFooter()}
                pt={{
                    message: {
                    style: { marginLeft: '0px' }
                    }
                }}
            />
        </>
    )
}

export default CreateDispatchNote;